import { Aim } from "./modules/aim";
import { Oracle } from "./modules/oracle";
import { Haymaket_NPI } from "./modules/hm-npi";
/**
 * Starting point of ISM Application.
 */
export class ISMController {
    constructor() {
        this.timeout = window.adstackData.ism.timeout || 1000; // timeout in seconds
        /**
         * services is a public property which is an array containing promise Fn of all identity service providers(lytics, aim, etc)
         */
        this.services = [];
        /**
         * servicesInstances is a public property which is an array containing instances of all service providers(lytics, aim, etc)
         */
        this.servicesInstances = [];
        /**
         * resolvedServicesData is a public property which is an array containing data of identity service providers which resolved in the given timeframe.
         */
        this.resolvedServicesData = [];
        /**
         * dataStack is a public property in which data received from all service providers is stored.
         */
        this.dataStack = window.adstackData.ism.dataStack || [];
        /**
         * To keep track of targeting data from all providers, so that targeting is set only once and not when data is received from each provider.
         */
        this.gamTargetingData = [];
        /**
         * Register a service if the respective service's plugin is enabled.
         */
        this.allServices = function () {
            if (window.aimData) {
                this.servicesInstances.push(new Aim(this));
            }
            if (window.oracleInfinityTag) {
                this.servicesInstances.push(new Oracle(this));
            }
            this.servicesInstances.push(new Haymaket_NPI(this));
            this.deleteLSStaleData();
        };
        /**
         * Array containing the promise(to fetch data) of all service providers.
         */
        this.registeredServices = () => {
            this.servicesInstances.forEach((service) => {
                this.registerService(service.fetchIdentityServiceProviderPromise());
            });
            return this.services;
        };
        /**
         * Get data related to a identityServiceProvider based on the parameter passed
         * @param provider - lytics, aim etc.
         * @return ISMProvider - is a new interface defined with certain properties. Data returned should be in this particular format.
         */
        this.getServiceData = function (identityServiceProvider) {
            let data = identityServiceProvider && this.dataStack.length && this.dataStack.find(function (value) {
                return value && value.identityServiceProvider.toLowerCase() == identityServiceProvider.toLowerCase();
            });
            return data;
        };
        /**
         * Method to get data of a specific identityServiceProvider that has been resolved.
         * Particularly used to check if the provider is resolved to set slot level targeting
         * @param provider
         */
        this.isServiceResolved = function (identityServiceProvider) {
            let data = identityServiceProvider && this.resolvedServicesData.find(function (value) {
                return value && value.identityServiceProvider.toLowerCase() == identityServiceProvider.toLowerCase();
            });
            return data;
        };
        /**
         * Get data from LocalStorage(LS)
         * @param identityServiceProvider - is an optional parameter. If it is sent, return data of only that identityServiceProvider.
         */
        this.getISMDataFromLocalStorage = function (identityServiceProvider) {
            let ISMLSData = [];
            /* Get ISM data stored in LS if present. Else define it as an empty array */
            ISMLSData = window.localStorage && JSON.parse(window.localStorage.getItem('ISMDataStack')) || ISMLSData;
            if (identityServiceProvider && ISMLSData.length) {
                let provider = [];
                let providerExists = ISMLSData.filter((item, index) => {
                    return item.identityServiceProvider.toLowerCase() === identityServiceProvider.toLowerCase();
                });
                if (providerExists.length) {
                    provider = providerExists;
                }
                return provider;
            }
            return ISMLSData;
        };
        /**
         * Save data of each identity service provider to LocalStorage(LS)
         * If its already present, replace it. Else add a new entry.
         * We also store expiry date for each provider but its not being used at the moment.
         */
        this.saveDataToLocalStorage = (serviceProviderData) => {
            let ISMLSData = [];
            /* Get ISM data stored in LS if present. Else define it as an empty array */
            ISMLSData = window.localStorage && JSON.parse(window.localStorage.getItem('ISMDataStack')) || ISMLSData;
            let providerExists = ISMLSData.findIndex((item, index) => {
                return item.identityServiceProvider.toLowerCase() === serviceProviderData.identityServiceProvider.toLowerCase();
            });
            const now = new Date();
            if (providerExists > -1) { // If provider already exists in LS, replace its value
                ISMLSData[providerExists].value = serviceProviderData.value;
                ISMLSData[providerExists].expiry = now.getTime() + this.lsExpiryTime;
            }
            else {
                serviceProviderData['expiry'] = now.getTime() + this.lsExpiryTime;
                ISMLSData.push(serviceProviderData);
            }
            window.localStorage && window.localStorage.setItem('ISMDataStack', JSON.stringify(ISMLSData));
        };
        this.lsExpiryTime = 60 * 60 * 24 * 1000 * 1; /* minutes * seconds * hours * milliseconds * number of days */
        this.allServices();
        this.timeout = window.darService ? window.darService.adstackData.ism.timeout : this.timeout;
    }
    registerService(service) {
        this.services.push(service);
    }
    /**
     * To handle/remove data stored in LS when a provider is deactivated.
     */
    deleteLSStaleData() {
        let providers = ['lytics'];
        if (!window.aimData) {
            providers.push('aim');
        }
        if (!window.oracleInfinityTag) {
            providers.push('oracle');
        }
        if (providers.length) {
            const LSData = this.getISMDataFromLocalStorage();
            if (LSData.length) {
                providers.forEach(function (provider) {
                    let providerExists = LSData.findIndex((item, index) => {
                        return item.identityServiceProvider.toLowerCase() === provider;
                    });
                    if (providerExists > -1) {
                        const removedItem = LSData.splice(providerExists, 1);
                        window.localStorage && window.localStorage.setItem('ISMDataStack', JSON.stringify(LSData));
                    }
                });
            }
        }
    }
}
